import { render, staticRenderFns } from "./ConfigLimitExcecution.vue?vue&type=template&id=0871c421&"
import script from "./ConfigLimitExcecution.vue?vue&type=script&lang=js&"
export * from "./ConfigLimitExcecution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports